import { AllLog } from '@@types/Log';

import DataSuper from '~/stores/data/DataSuper';

class ChannelLogData extends DataSuper<AllLog> {}

export default ChannelLogData;

export const channelLogData = new ChannelLogData();
